// extracted by mini-css-extract-plugin
export default {"scanner":"style_scanner__avZW+"};